const getFirstVariantWithSameOption = (
  option,
  value,
  optionIndex,
  allVariants
) => {
  return allVariants.find(variant => {
    return variant.options[optionIndex] === value;
  });
};

const getVariantFromSelection = (
  option,
  value,
  optionIndex,
  currentVariant,
  allVariants
) => {
  const potentialVariants = allVariants.filter(variant => {
    return (
      // Check the variant has the option we've just selected
      variant.options[optionIndex] === value &&
      // Check the variant has the options we've already got selected
      variant.options.filter((optionValue, index) => {
        // Skip the option we're changing
        if (index === optionIndex) {
          return false;
        }

        return currentVariant.options[index] === optionValue;
      }).length === 1
    );
  });

  // If we've got more than one (e.g., one is in stock and the other is
  // a pre-order), then just return the first, in stock one.
  //
  // If there's just one, we can return that safely here, too.
  if (potentialVariants.length > 0) {
    return potentialVariants[0];
  }

  // If we can't find anything, then we need to return the first variant
  // that has the option we selected. It might not be available in the current
  // colour, or the current frame size, but we need to return something.
  return getFirstVariantWithSameOption(option, value, optionIndex, allVariants);
};

export default getVariantFromSelection;
